import { Controller } from "@hotwired/stimulus"

// Reveals the self signup confirmation only when the flag is being turned on
// from off. An account that is already public is not re-confirmed on every
// edit, and turning the flag off is never obstructed.
//
// This is a prompt, not the control. Account validates the same rule server
// side, so a form posted without the confirmation is rejected regardless of
// what happens in the browser.
export default class extends Controller {
  static targets = ["flag", "confirmation", "acknowledgement"]
  static values = { enabled: Boolean }

  connect() {
    this.refresh()
  }

  refresh() {
    const turningOn = this.flagTarget.checked && !this.enabledValue

    this.confirmationTarget.classList.toggle("hidden", !turningOn)

    if (!turningOn && this.hasAcknowledgementTarget) {
      this.acknowledgementTarget.checked = false
    }
  }
}
